import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { ToastContainer, toast } from 'react-toastify';
import { Customer } from '../../customerManager/model/Customer.ts';
import {updateCustomerById} from '../../customerManager/api/CustomerManager.api.js'
import { COUNTRIES, STATES_BY_COUNTRY } from '../utils/countryStateCatalog.js';

interface SaveOrEditCustomerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCloseCancel?: () => void;
  customer?: Customer;
}

const SaveOrEditCustomer: React.FC<SaveOrEditCustomerModalProps> = ({ isOpen, onClose, onCloseCancel, customer}) => {
  
  
  const [loading, setLoading] = useState(false);
  // Kept as text while editing; empty means "no limit configured" and is not sent.
  const [slotsInput, setSlotsInput] = useState<string>("");

  const [formData, setFormData] = useState<Customer>({
    id: "", 
    name: "",
    customerId: "",
    createdAt: "",
    active: true,
    mainUserName: "",
    mainUserPhone: "",
    mainUserEmail: "",
    logo: "",
    instagramUrl: "",
    identifier: "",
    showWork: true,
    termsAndConditions: true,
    country: "",
    state: "",
    street: "",
    streetNumber: ""
  });

  

  useEffect(() => {
    if (customer) {
        setFormData(customer);
        setSlotsInput(customer.enabledSlots === null || customer.enabledSlots === undefined ? "" : String(customer.enabledSlots));
    } else {
        setSlotsInput("");
        setFormData({
            id: "", 
            name: "",
            customerId: "",
            createdAt: "",
            active: true,
            mainUserName: "",
            mainUserPhone: "",
            mainUserEmail: "",
            logo: "",
            instagramUrl: "",
            identifier: "",
            showWork: true,
            termsAndConditions: true,
            country: "",
            state: "",
            street: "",
            streetNumber: ""
        });
    }
  }, [customer]);



const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    
    let inputValue: string | boolean = value;

  if (type === "checkbox") {
    inputValue = (e.target as HTMLInputElement).checked;
  } else if (value === "true" || value === "false") {
    inputValue = value === "true";
  }

    if (name === "country") {
      setFormData({ ...formData, country: inputValue, state: "" });
    } else {
      setFormData({ ...formData, [name]: inputValue });
    }
  };




  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const slotsText = slotsInput.trim();
    if (slotsText !== "" && !/^\d+$/.test(slotsText)) {
      toast.error("Los slots habilitados deben ser un número entero mayor o igual a 0.");
      return;
    }
    setLoading(true);

    const dataToUpdate: Record<string, unknown> = {
      name: formData.name,
      mainUserName: formData.mainUserName,
      mainUserEmail: formData.mainUserEmail,
      logo: formData.logo,
      instagramUrl: formData.instagramUrl,
      active: formData.active,
      showWork: formData.showWork,
      termsAndConditions: formData.termsAndConditions,
      mainUserPhone: formData.mainUserPhone,
      country: formData.country,
      state: formData.state,
      street: formData.street,
      streetNumber: formData.streetNumber,
    };
    if (slotsText !== "") {
      dataToUpdate.enabledSlots = parseInt(slotsText, 10);
    }

    try {
      console.log("Saving Customer:", dataToUpdate);
      if (formData.id && formData.id.trim() !== "") {
        // UPDATE
        const response = await updateCustomerById(formData.id, dataToUpdate);
        console.log("updateCustomer called with id:", formData.id);
      } else {
        // CREATE
        // await createCustomer(formData);
        console.log("createCustomer called");
      }

      
      toast.success(`Cliente ${formData.id ? 'editado' : 'guardado'} exitosamente`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      setLoading(false);
      onClose();
    } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 409) {
            toast.error("El cliente ya existe", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } else if (axios.isAxiosError(error) && error.response?.status === 403) {
            toast.error("Solo un administrador puede modificar los slots habilitados del cliente.", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } else if (axios.isAxiosError(error) && error.response?.status === 422) {
            console.error("Error al sincronizar el estado del cliente:", error);
            toast.error(error.response?.data?.error || "No se pudo sincronizar el estado del cliente.", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } else if (error instanceof Error) {
            console.error("Error al guardar el cliente:", error);
            toast.error("Error al guardar el cliente.", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } else {
            console.error("Error:", error);
        }
        setLoading(false);
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start pt-12 z-50 overflow-y-auto">
      <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-2xl my-8 mx-4">
        
        <div className="flex justify-between items-center border-b pb-4 mb-4">
          <h2 className="text-xl font-bold">{customer ? 'Editar Cliente' : 'Añadir Nueva Cliente'}</h2>
          <button className="text-gray-500 hover:text-gray-700 text-2xl" onClick={onCloseCancel}>&times;</button>
        </div>
        
        <div>
          <form onSubmit={handleSubmit}>
            
            <div className="mb-4">
              <label htmlFor="name" className="block text-gray-700 font-medium mb-1 after:content-['*'] after:ml-1 after:text-red-500">Nombre</label>
              <input type="text" id="name" name="name" value={formData.name} onChange={handleInputChange} className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required />
            </div>

            <div className="mb-4">
              <label htmlFor="customerId" className="block  text-gray-700 font-medium mb-1 after:content-['*'] after:ml-1 after:text-red-500">ID</label>
              <input type="text" id="customerId" name="customerId" value={formData.customerId} onChange={handleInputChange} className="w-full p-2 border bg-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" readOnly />
            </div>

            <div className="mb-4">
              <label htmlFor="identifier" className="block  text-gray-700 font-medium mb-1 after:content-['*'] after:ml-1 after:text-red-500">PWD</label>
              <input type="text" id="identifier" name="identifier" value={formData.identifier} onChange={handleInputChange} className="w-full p-2 border bg-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" readOnly />
            </div>

            <div className="mb-4">
              <label htmlFor="createdAt" className="block text-gray-700 font-medium mb-1 after:content-['*'] after:ml-1 after:text-red-500">Creado el</label>
              <input type="text" id="createdAt" name="createdAt" value={formData.createdAt ? new Date(formData.createdAt).toLocaleDateString('es-AR', { year: 'numeric', month: '2-digit', day: '2-digit' }) : ''} onChange={handleInputChange} className="w-full p-2 border bg-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" readOnly />
            </div>

            <div className="mb-4">
              <label htmlFor="mainUserName" className="block text-gray-700 font-medium mb-1 after:content-['*'] after:ml-1 after:text-red-500">Nombre del usuario principal</label>
              <input type="text" id="mainUserName" name="mainUserName" value={formData.mainUserName} onChange={handleInputChange} className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required />
            </div>

            <div className="mb-4">
              <label htmlFor="mainUserEmail" className="block text-gray-700 font-medium mb-1 after:content-['*'] after:ml-1 after:text-red-500">Mail del usuario principal</label>
              <input type="text" id="mainUserEmail" name="mainUserEmail" value={formData.mainUserEmail} onChange={handleInputChange} className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required />
            </div>

            <div className="mb-4">
              <label htmlFor="mainUserPhone" className="block text-gray-700 font-medium mb-1 after:content-['*'] after:ml-1 after:text-red-500">Teléfono del usuario principal</label>
              <input type="text" id="mainUserPhone" name="mainUserPhone" value={formData.mainUserPhone} onChange={handleInputChange} className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required />
            </div>

            <div className="mb-4">
              <label htmlFor="logo" className="block text-gray-700 font-medium mb-1">Logo URL</label>
              <input type="text" id="logo" name="logo" value={formData.logo} onChange={handleInputChange} className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"  />
            </div>

            <div className="mb-4">
              <label htmlFor="instagramUrl" className="block text-gray-700 font-medium mb-1">Instagram</label>
              <input type="text" id="instagramUrl" name="instagramUrl" value={formData.instagramUrl} onChange={handleInputChange} className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"  />
            </div>

            <div className="mb-4">
              <label htmlFor="country" className="block text-gray-700 font-medium mb-1">País</label>
              <select
                id="country"
                name="country"
                value={formData.country || ""}
                onChange={handleInputChange}
                className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Seleccionar país</option>
                {COUNTRIES.map((c) => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
            </div>

            <div className="mb-4">
              <label htmlFor="state" className="block text-gray-700 font-medium mb-1">Provincia/Estado</label>
              {formData.country && STATES_BY_COUNTRY[formData.country] ? (
                <select
                  id="state"
                  name="state"
                  value={formData.state || ""}
                  onChange={handleInputChange}
                  className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Seleccionar provincia/estado</option>
                  {STATES_BY_COUNTRY[formData.country].map((s) => (
                    <option key={s} value={s}>{s}</option>
                  ))}
                </select>
              ) : (
                <input
                  type="text"
                  id="state"
                  name="state"
                  value={formData.state || ""}
                  onChange={handleInputChange}
                  placeholder={formData.country ? "" : "Elegí un país primero"}
                  className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              )}
            </div>

            <div className="mb-4">
              <label htmlFor="street" className="block text-gray-700 font-medium mb-1">Calle</label>
              <input type="text" id="street" name="street" value={formData.street} onChange={handleInputChange} className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
            </div>

            <div className="mb-4">
              <label htmlFor="streetNumber" className="block text-gray-700 font-medium mb-1">Número</label>
              <input type="text" id="streetNumber" name="streetNumber" value={formData.streetNumber} onChange={handleInputChange} className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
            </div>

            <div className="mb-4">
              <label htmlFor="enabledSlots" className="block text-gray-700 font-medium mb-1">Slots habilitados</label>
              <input
                type="number"
                id="enabledSlots"
                name="enabledSlots"
                min={0}
                step={1}
                value={slotsInput}
                onChange={(e) => setSlotsInput(e.target.value)}
                placeholder="Sin límite configurado"
                className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <p className="text-sm text-gray-500 mt-1">
                {formData.activeCameras ?? 0} {formData.activeCameras === 1 ? "cámara activa" : "cámaras activas"} actualmente
                (no cuentan las Terminadas ni Suspendidas).
              </p>
            </div>

            <div className="mb-4">
              <label htmlFor="active" className="block text-gray-700 font-medium mb-1">Activo</label>
              <select
                id="active"
                name="active"
                value={formData.active ? "true" : "false"}
                className="w-full p-2 border rounded-md"
                onChange={handleInputChange}
              >
                <option value="true">Sí</option>
                <option value="false">No</option>
              </select>
            </div>

            <div className="mb-4">
              <label htmlFor="showWork" className="block text-gray-700 font-medium mb-1">Visible</label>
              <select
                id="showWork"
                name="showWork"
                value={formData.showWork ? "true" : "false"}
                className="w-full p-2 border rounded-md"
                onChange={handleInputChange}
              >
                <option value="true">Sí</option>
                <option value="false">No</option>
              </select>
            </div>

            <div className="mb-4">
              <label htmlFor="termsAndConditions" className="block text-gray-700 font-medium mb-1">Term. & Condiciones</label>
              <select
                id="termsAndConditions"
                name="termsAndConditions"
                value={formData.termsAndConditions ? "true" : "false"}
                className="w-full p-2 border rounded-md"
                onChange={handleInputChange}
              >
                <option value="true">Sí</option>
                <option value="false">No</option>
              </select>
            </div>

            <hr className="my-6 border-gray-200" />

            <div className="flex justify-end gap-2">
              <button
                type="button"
                className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 transition-colors"
                onClick={onCloseCancel}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors disabled:bg-blue-300 disabled:cursor-not-allowed"
                disabled={loading}
              >
                {loading ? "Guardando..." : "Guardar"}
              </button>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default SaveOrEditCustomer;
